import { TextField } from "@mui/material";
import { useEffect, useState } from "react";

const QCEditableCell = ({
  query,
  parameterIndex,
  handleBlur,
  isDisabled,
  onClickCellToRedirect,
  role,
}) => {
  const [text, setText] = useState(query || "");

  useEffect(() => {
    setText(query);
  }, [query]);

  const handleChange = (e) => {
    setText(e.target.value);
  };

  return (
    <TextField
      className="parameters-name"
      multiline
      id="standard-basic"
      variant="standard"
      value={text}
      onChange={(e) => handleChange(e)}
      onBlur={(event) => handleBlur(text, parameterIndex, query)}
      InputProps={{
        readOnly: isDisabled,
      }}
      onClick={() => {
        if (role !== "preProcessor") {
          onClickCellToRedirect();
        }
      }}
    />
  );
};

QCEditableCell.defaultProps = {
  isDisabled: false,
};

export default QCEditableCell;
